<template>
  <v-card outlined>
    <v-card-title>
      Дополнительные коэффициенты
    </v-card-title>
    <v-toolbar dense flat>
      <v-dialog v-model="editor" max-width="480">
        <template #activator="{ on, attr }">
          <v-row align="center">
            <v-col cols="6">
              <v-btn text color="primary" v-bind="attr" v-on="on">
                <v-icon left>mdi-plus</v-icon>
                <span>Добавить</span>
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <rating-rule-editor
          v-model="item"
          :activityTypes="activityTypes"
          @close="close"
          @save="save"
        />
      </v-dialog>
    </v-toolbar>
    <v-data-table
      dense
      :headers="headers"
      :items="items"
      :loading="loading"
      item-key="id"
      @click:row="open"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.actions="{ item }">
        <deleting-dialog
          :data="item"
          title="Удаление"
          message="Удалить правило?"
          @delete-request="deleteItem"
        />
      </template>
      <template v-slot:item.label="{ item }">
        {{ ruleNames[item.label] || "-" }}
      </template>
      <template v-slot:item.data="{ item }">
        <span v-if="item.label == 'points'"
          >{{ item.data.min }} ≤ X &lt; {{ item.data.max }}</span
        >
        <span v-if="item.label == 'course'">
          до выпуска: {{ item.data.course }}</span
        >
      </template>
    </v-data-table>
    <v-toolbar dense flat>
      <span>Не входит в:</span>
      <span v-for="item in emptyItems" :key="item.label">
        <span class="ml-6">
          {{ ruleNames[item.label] || "-" }} : {{ item.requestCount }}
        </span>
      </span>
    </v-toolbar>
  </v-card>
</template>
<script>
import {
  getRatingRules,
  createRatingRule,
  updateRatingRule,
  deleteRatingRule,
  getEmptyRatingRules
} from "../../services/rating.service";
import DeletingDialog from "../DeletingDialog.vue";
import RatingRuleEditor from "./RatingRuleEditor.vue";

export default {
  name: "RatingRuleList",

  props: {
    rating: { type: Object, required: true },
    activityTypes: { type: Array, default: () => [] }
  },

  components: { DeletingDialog, RatingRuleEditor },

  computed: {},

  data() {
    return {
      headers: [
        { text: "Вид деятельности", value: "typeName" },
        { text: "Тип", value: "label" },
        { text: "Правило", value: "data" },
        { text: "Коэффициент", value: "index" },
        { text: "Количество заявок", value: "requestCount" },
        { text: "Действия", value: "actions" }
      ],
      ruleNames: {
        course: "Правило по курсу",
        points: "Правило по баллам"
      },
      items: [],
      emptyItems: [],
      item: { data: {} },

      loading: false,
      editor: false
    };
  },

  watch: {
    rating: {
      handler(v) {
        this.load();
      },
      immediate: true
    },

    editor(opened) {
      if (!opened) this.item = { data: {} };
    }
  },

  methods: {
    async load() {
      if (this.rating.id) {
        try {
          this.loading = true;
          this.items = await getRatingRules(this.rating.id);
          this.emptyItems = await getEmptyRatingRules(this.rating.id);
        } catch (e) {
          this.$notify({
            text: e.response ? e.response.data.message : e,
            type: "error"
          });
        } finally {
          this.loading = false;
        }
      } else {
        this.items = [];
      }
    },
    async deleteItem(item) {
      try {
        await deleteRatingRule(item.id);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      } finally {
        this.$emit("update");
      }
    },

    open(item) {
      this.item = item;
      this.editor = true;
    },

    close() {
      this.editor = false;
    },

    async save(ratingRule) {
      try {
        if (!ratingRule.id) {
          await createRatingRule(this.rating.id, ratingRule);
        } else {
          await updateRatingRule(ratingRule.id, ratingRule);
        }
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      } finally {
        this.$emit("update");
      }
    }
  }
};
</script>
